import { useQuery } from '@tanstack/react-query';

import { getClinicMessageStats } from 'app/services/clinic';

export const getClinicMessageStatsKey = (clinicId) => ['clinicMessageStats', clinicId];

export default function useClinicMessageStats(clinicId) {
  return useQuery({
    queryKey: getClinicMessageStatsKey(clinicId),
    queryFn: () => getClinicMessageStats(clinicId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(clinicId),
  });
}
